import React, { Component } from 'react';

class Button extends Component {

  handleClick(e) {
    if (typeof this.props.onClick !== 'undefined') {
      e.preventDefault();
      this.props.onClick(e);
    }
  }

  render() {
    let classes = ['waves-effect', 'waves-light'];

    if (this.props.large) {
      classes.push('btn-large');
    }
    else if (this.props.flat) {
      classes.push('btn-flat');
    } else {
      classes.push('btn');
    }

    if (this.props['z-depth']) {
      classes.push(`z-depth-${this.props['z-depth']}`);
    }

    if (this.props.color) {
      classes.push(this.props.color);
    }

    if(this.props.className){
      classes.push(this.props.className)
    }

    return (
      <button
        className={ classes.join(' ') }
        disabled={this.props.disabled || false}
        type={ typeof this.props.type === 'undefined' ? 'submit' : this.props.type }
        onClick={ this.handleClick.bind(this) }>
        { this.props.beforeIcon ? <i className="material-icons before-icon">{this.props.beforeIcon}</i> : '' }
        <span>{ this.props.children }</span>
        { this.props.afterIcon ? <i className="material-icons after-icon">{this.props.afterIcon}</i> : '' }
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js